<section class="m-4">
  <!-- Header with Back Button and Title -->
  <div class="CHeading_Container">
    <div class="list_Header_section">
      <div class="d-flex Header_title_section">
        <button class="back_icon me-2" (click)="navigateBack()">
          <i class="fa-solid fa-arrow-left"></i>
        </button>
        <div class="page_header">
          <h5 class="my-0 p-2 page_header_title" translate>Careers List</h5>
        </div>
      </div>

      <div>
        <button
          mat-raised-button
          color="primary"
          (click)="openJobForm()"
          translate
        >
          + Add Job Posting
        </button>
      </div>
    </div>
  </div>
  <!-- Centered Content (Empty State) -->
  <div *ngIf="CareersList.length === 0 && !showForm" class="center-container">
    <div class="text-center">
      <p class="mb-4" translate>
        Page is empty. Add a sub page to upload the documents.
      </p>
      <button
        mat-raised-button
        color="primary"
        (click)="openJobForm()"
        translate
      >
        Create New Job Post
      </button>
    </div>
  </div>

  <div *ngIf="showForm" class="career-form-section">
    <form (ngSubmit)="onSubmit()" [formGroup]="form">
      <!-- Basic Details Section -->
      <div>
        <div class="page_header">
          <h3 class="my-0 p-2 page_header_title" translate>Basic Details</h3>
        </div>
        <div class="career-basic-form-box">
          <div class="career-form-row">
            <div *ngFor="let question of questions" class="career-form-field">
              <app-question [question]="question" [form]="form"></app-question>
            </div>
            <!-- Toggle placed after all fields -->
            <div class="contact-toggle-field p-3">
              <mat-label translate>Show contact Details to Applicant</mat-label>
              <mat-button-toggle-group
                formControlName="is_published"
                aria-label="Show contact details toggle"
                appearance="legacy"
                class="ms-3 toggle_box"
                exclusive
              >
                <mat-button-toggle [value]="true" translate
                  >Yes</mat-button-toggle
                >
                <mat-button-toggle [value]="false" translate
                  >No</mat-button-toggle
                >
              </mat-button-toggle-group>
            </div>
          </div>
        </div>
      </div>
      <!-- Description Section -->
      <div>
        <div class="page_header">
          <h3 class="my-0 p-2 page_header_title" translate>Job Description</h3>
        </div>
        <div class="career-JD-form-box">
          <div>
            <div class="p-2 mx-0">
              <h4 class="f-bold" translate>Company Profile:</h4>
              <mat-form-field class="w-100">
                <textarea
                  matInput
                  formControlName="company_profile"
                  rows="7"
                  placeholder="Write about company"
                ></textarea>
              </mat-form-field>
            </div>

            <div class="p-2">
              <h4 translate>Job Description:</h4>
              <quill-editor
                formControlName="jd_url"
                [modules]="quillConfig"
                (onSelectionChanged)="onSelectionChanged($event)"
                (onContentChanged)="onContentChanged($event)"
                style="direction: ltr; text-align: left"
                style="height: 25vh"
              ></quill-editor>
            </div>
            <div class="p-2">
              <h4 translate>Skills:</h4>
              <mat-form-field class="w-100" appearance="outline">
                <input
                  [matChipInputFor]="chipGrid"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  [matChipInputAddOnBlur]="true"
                  (matChipInputTokenEnd)="addSkill($event)"
                  placeholder="Add Skill..."
                />

                <!-- Chips Grid (renders below input) -->
                <mat-chip-grid #chipGrid class="chips-container">
                  <mat-chip-row
                    *ngFor="let skill of skillList"
                    [removable]="true"
                    [editable]="true"
                    (removed)="removeSkill(skill)"
                    (edited)="editSkill(skill, $event)"
                  >
                    {{ skill }}
                    <button matChipRemove>
                      <i class="fa-solid fa-xmark"></i>
                    </button>
                  </mat-chip-row>
                </mat-chip-grid>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
      <div class="text-center p-4">
        <button mat-raised-button color="primary" type="submit" translate>
          Submit
        </button>
      </div>
    </form>
  </div>

  <!-- Alternate Content (List) -->
  <div *ngIf="CareersList.length > 0 && !showForm" class="p-3 container">
    <div class="tblmaind">
      <table mat-table [dataSource]="CareersList" class="mat-elevation-z8">
        <!-- Serial Number -->
        <ng-container matColumnDef="created_at">
          <th mat-header-cell *matHeaderCellDef translate>Start Date</th>
          <td mat-cell *matCellDef="let element">{{ element.created_at }}</td>
        </ng-container>
        <!-- Info -->
        <ng-container matColumnDef="position_name">
          <th mat-header-cell *matHeaderCellDef translate>Position</th>
          <td mat-cell *matCellDef="let element">
            {{ element.position_name }}
          </td>
        </ng-container>
        <ng-container matColumnDef="department_name">
          <th mat-header-cell *matHeaderCellDef translate>Department</th>
          <td mat-cell *matCellDef="let element">
            {{ element.department_name }}
          </td>
        </ng-container>
        <ng-container matColumnDef="number_of_openings">
          <th mat-header-cell *matHeaderCellDef translate>
            Number Of Openings
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.number_of_openings }}
          </td>
        </ng-container>
        <ng-container matColumnDef="experience_in_years">
          <th mat-header-cell *matHeaderCellDef translate>Experience Needed</th>
          <td mat-cell *matCellDef="let element">
            {{ element.experience_in_years }}
          </td>
        </ng-container>
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef translate>Status</th>
          <td mat-cell *matCellDef="let element">
            <p>
              {{ element.status }}
            </p>
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef translate>Actions</th>
          <td mat-cell *matCellDef="let element">
            <div class="d-flex align-items-center">
              <button
                mat-button
                class="view_button"
                (click)="viewCareerDetails(element.id)"
                translate
              >
                View
              </button>
              <div
                class="action_button"
                [matMenuTriggerFor]="menu"
                aria-label="Actions"
              >
                <i class="fa-solid fa-ellipsis-vertical"></i>
              </div>
            </div>
            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="editCareersData(element.id)">
                <i class="fa-solid fa-pen-to-square"></i>
                <span translate>Edit</span>
              </button>
              <button mat-menu-item (click)="updateCareerStatus(element)">
                <i class="fas fa-toggle-on"></i>{{ element.status }}
              </button>
              <button
                mat-menu-item
                class="delete_button"
                (click)="deleteCareers(element.id)"
              >
                <i class="fa-solid fa-trash"></i> <span translate>Delete</span>
              </button>
              <!-- <button
                mat-menu-item
                class="delete_button"
                (click)="handleApplicantView(element.id)"
              >
                <i class="fa fa-eye"></i> <span translate>View Applicant</span>
              </button> -->
            </mat-menu>
          </td>
        </ng-container>

        <!-- Update Table Header and Row -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  </div>
</section>
